/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Match_Male13Inputs */

const en__field_enum_tuda_match_male13 = /** @type {(inputs: _Field_Enum_Tuda_Match_Male13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Men`)
};

const de__field_enum_tuda_match_male13 = /** @type {(inputs: _Field_Enum_Tuda_Match_Male13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mann`)
};

/**
* | output |
* | --- |
* | "Men" |
*
* @param {_Field_Enum_Tuda_Match_Male13Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_match_male13 = /** @type {((inputs?: _Field_Enum_Tuda_Match_Male13Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Match_Male13Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_match_male13(inputs)
	return de__field_enum_tuda_match_male13(inputs)
});
export { _field_enum_tuda_match_male13 as "_field_enum_TUDA_MATCH_MALE" }